'use strict';

var SystemStatusFaresReoptDirective = function SystemStatusFaresReoptDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-fares-reopt.html'),
    controller: 'SystemStatusFaresReoptController',
    link: function link(scope) {
      scope.$on('system-status-fares-reoptimization:reoptimize', scope.reoptimize);
    }
  };
};
SystemStatusFaresReoptDirective.$inject = [];
module.exports = SystemStatusFaresReoptDirective;